import SquareOutlineIcon from 'mdi-react/SquareOutlineIcon';
import RectangleOutlineIcon from 'mdi-react/RectangleOutlineIcon';
import CircleOutlineIcon from 'mdi-react/CircleOutlineIcon';
import TriangleOutlineIcon from 'mdi-react/TriangleOutlineIcon';
import VectorLineIcon from 'mdi-react/VectorLineIcon';
import type { EditorTool } from '../models/editor-tool';

/** The shapes anybody can put on a floor with two clicks. */
export type BasicShapeTool = Extract<EditorTool, 'square' | 'rectangle' | 'circle' | 'triangle' | 'line'>;

/** One list for the toolbox tray and the Floor panel, so the two always offer the same shapes. */
export const BASIC_SHAPES: ReadonlyArray<{
  readonly tool: BasicShapeTool;
  readonly labelKey: string;
  readonly Icon: typeof SquareOutlineIcon;
}> = [
  { tool: 'square', labelKey: 'floorplan-simple-shape-square', Icon: SquareOutlineIcon },
  { tool: 'rectangle', labelKey: 'floorplan-simple-shape-rectangle', Icon: RectangleOutlineIcon },
  { tool: 'circle', labelKey: 'floorplan-simple-shape-circle', Icon: CircleOutlineIcon },
  { tool: 'triangle', labelKey: 'floorplan-simple-shape-triangle', Icon: TriangleOutlineIcon },
  { tool: 'line', labelKey: 'floorplan-simple-shape-line', Icon: VectorLineIcon },
];
